import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TheNeed } from './components/TheNeed';
import { WhyCancun } from './components/WhyCancun';
import { OurVision } from './components/OurVision';
import { GlobalNetwork } from './components/GlobalNetwork';
import { WeddingEcosystem } from './components/WeddingEcosystem';
import { WeddingDateInquiry } from './components/WeddingDateInquiry';
import { WhatThisMakesPossible } from './components/WhatThisMakesPossible';
import { FundingPathways } from './components/FundingPathways';
import { FoundingCircle } from './components/FoundingCircle';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { LanguageProvider } from './lib/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-ivory font-sans text-navy antialiased selection:bg-saffron/30" data-id="element-1">
        <Navbar data-id="element-2" />

        <main data-id="element-3">
          <Hero data-id="element-4" />
          <TheNeed data-id="element-5" />
          <WhyCancun data-id="element-6" />
          <OurVision data-id="element-7" />
          <GlobalNetwork data-id="element-8" />
          <WeddingEcosystem data-id="element-9" />
          <WeddingDateInquiry data-id="element-10" />
          <WhatThisMakesPossible data-id="element-11" />
          <FundingPathways data-id="element-12" />
          <FoundingCircle data-id="element-13" />
          <FAQ data-id="element-14" />
        </main>

        <footer data-id="element-15">
          <FinalCTA data-id="element-16" />
        </footer>

        <StickyMobileCTA data-id="element-17" />
      </div>
    </LanguageProvider>;
}